import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { getStatusColor, getStatusText } from "../../Common/Utils/statusUtils";
import search from "../../assets/images/search-lg.svg";
import { deleteAdmin, getAdminList } from "../../../redux/admin/action";
import ModalDelete from "../../Common/Popup/ModalDelete";
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";
import "../../Common/Styles/Listing.css";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";

const SubcategoryList = () => {
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const [componentList, setComponentList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminlist = useSelector(({ admin: { adminList } }) => adminList);

  useEffect(() => {
    if (adminlist) {
      setComponentList(adminlist.admins || []);
    }
  }, [adminlist]);

  useEffect(() => {
    dispatch(getAdminList(params, setLoading));
  }, [dispatch, params]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteAdmin(currentComponent.id, setLoading, params));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const addComponent = () => {
    navigate("/admin/add");
  };

  const updateComponent = (id) => {
    navigate(`/admin/update/${id}`);
  };

  return (
    <Card className="">
      <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? `overlay show` : "overlay"}
      ></div>
      <NormalCardHeader
        headerTitle="Admin List"
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
        addName="Admin"
      />
      {loading ? (
        <FullScreenLoader />
      ) : (
        <CardBody className="table-sec px-3">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Full Name</th>
                <th scope="col">Contact</th>
                {/* <th scope="col">Email</th> */}
                <th scope="col">Status</th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {componentList.length > 0 ? (
                componentList.map((item, index) => (
                  <tr key={item.id}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td className="w-25">
                      {item?.first_name} {item?.last_name}
                    </td>
                    {/* <td>{`${}${item?.mobile_number}`}</td> */}
                    <td>
                      <p>{` ${item?.country_code}  ${item?.mobile_number}`}</p>
                      <p>{` ${item?.email_id}`}</p>
                    </td>
                    <td>
                      <span style={{ color: getStatusColor(item?.status) }}>
                        {getStatusText(item?.status)}
                      </span>
                    </td>
                    <td>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          className="border-button"
                          onClick={() => updateComponent(item.id)}
                        >
                          <span>Update</span>
                        </button>
                        <button
                          className="background-button"
                          onClick={() => {
                            setModal(true);
                            setCurrentComponent(item);
                          }}
                        >
                          <span>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Admins found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={adminlist?.pagination_meta}
          />
        </CardBody>
      )}
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <ModalDelete
          modalTitle="Admin"
            // itemType="admin"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </Card>
  );
};

export default SubcategoryList;
